<template>
  <div class="qrcode__img--container qrcode--hide">
    <div
      class="qrcode__img--time"
      v-if="!refetchEnabled"
    >
      <jade-spinner
        :size="SIZE_ENUM.SMALL"
        :color="COLOR_ENUM.BRAND"
      />
      <jade-text>
        {{ $t('time-text') }}
      </jade-text>
      <jade-text
        :color="COLOR_ENUM.BRAND"
        weight="semibold"
      >
        {{ parsedCountdown }}
      </jade-text>
    </div>
    <div class="qrcode--container">
      <div
        class="qrcode__img"
        :class="{ 'qrcode--opacity': refetchEnabled }"
        ref="img"
        v-bind:style="{
          'background-image': `url('data:image/svg+xml;base64,${
            !!kycQrCode && kycQrCode.base64_qrcode
          }')`
        }"
      ></div>
      <jade-button
        v-if="refetchEnabled"
        class="qrcode__button"
        icon="action-refresh"
        :loading="loadingKycQrCode"
        :size="SIZE_ENUM.SMALL"
        variant="primary-solid"
        @click="retryQrCode"
      >
        {{ $t('new-qr-code') }}
      </jade-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JadeButton from '@jade/JadeButton/index.vue'
import JadeSpinner from '@jade/JadeSpinner/index.vue'
import JadeText from '@jade/JadeText/index.vue'

import COLOR_ENUM from '@jade/enums/colors.enum'
import SIZE_ENUM from '@jade/enums/sizes.enum'

import DateManager from '@/utils/date-manager.utils'

const ONE_SECOND_IN_MILLISECONDS = 1000
const ONE_MINUTE_IN_SECONDS = 60

const TIMEZONE_OFFSET =
  new Date().getTimezoneOffset() *
  ONE_MINUTE_IN_SECONDS *
  ONE_SECOND_IN_MILLISECONDS

export default {
  name: 'QrCodeKyc',
  components: {
    JadeButton,
    JadeSpinner,
    JadeText
  },
  data () {
    return {
      countdowmIntervalRef: null,
      refetchEnabled: false,
      remainingTimeInSeconds: 0,
      parsedCountdown: '00:00',
      COLOR_ENUM,
      SIZE_ENUM
    }
  },
  computed: {
    ...mapGetters(['kycQrCode', 'loadingKycQrCode'])
  },
  methods: {
    ...mapActions({ createKycQrCode: 'CREATE_KYC_QR_CODE' }),
    getRemainingTimeInSeconds () {
      const expiresAtTimeStamp =
        new Date(this.kycQrCode.expires_at).getTime() + TIMEZONE_OFFSET

      const nowTimeStamp = new Date().getTime()

      const remainingTimeInSeconds =
        (expiresAtTimeStamp - nowTimeStamp) / ONE_SECOND_IN_MILLISECONDS

      return remainingTimeInSeconds
    },
    decreaseCountdown () {
      this.remainingTimeInSeconds--

      if (this.remainingTimeInSeconds <= 0) {
        clearInterval(this.countdowmIntervalRef)
        this.$emit('qrCodeExpired')
        this.refetchEnabled = true
        return
      }

      this.parsedCountdown = DateManager.convertSecondsToMinutes(
        this.remainingTimeInSeconds
      )
    },
    startCountdown () {
      this.remainingTimeInSeconds = this.getRemainingTimeInSeconds()
      this.parsedCountdown = DateManager.convertSecondsToMinutes(
        this.remainingTimeInSeconds
      )
      this.countdowmIntervalRef = setInterval(
        this.decreaseCountdown,
        ONE_SECOND_IN_MILLISECONDS
      )
    },
    fetchQrCode () {
      this.createKycQrCode()
        .then(() => {
          this.refetchEnabled = false
          this.startCountdown()
        })
        .catch(() => {
          this.$emit('createKycCodeError')
        })
    },
    retryQrCode () {
      clearInterval(this.countdowmIntervalRef)

      this.fetchQrCode()
    }
  },
  created () {
    this.fetchQrCode()
  }
}
</script>

<style scoped>
@import '@stone-payments/jade-design-tokens/pagarme/space.css';

.qrcode__img--container {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  justify-content: center;
}

.qrcode__img--time {
  display: flex;
  align-items: center;
}

.qrcode__img--container {
  gap: var(--global-space-200, 16px);
}

.qrcode__img--time {
  gap: var(--global-space-100, 8px);
}

.qrcode--hide {
  display: none;
}

.qrcode--container {
  position: relative;
}

.qrcode__img {
  width: 200px;
  height: 200px;
  background-size: contain;
}

.qrcode--opacity {
  opacity: 0.1;
}

.qrcode__button {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
}

@media (min-width: 768px) {
  .qrcode--hide {
    display: flex;
  }
}
</style>

<i18n>
    {
      "pt-BR": {
        "time-text": "Expira em",
        "new-qr-code": "Criar novo QR Code"
      },
      "en-US": {
        "time-text": "Expires in",
        "new-qr-code": "Create new QR Code"
      }
    }
</i18n>
